import { Box, Skeleton, useColorModeValue } from "@chakra-ui/react";
import React from "react";

const ChatBoxShimmer = () => {
  // Define subtle skeleton colors for minimal contrast
  const skeletonStartColor = useColorModeValue("gray.100", "gray.700");
  const skeletonEndColor = useColorModeValue("gray.300", "gray.800");

  return (
    <Box
      shadow="lg"
      borderRadius="xl"
      p={{ base: 4, md: 6 }} // Responsive padding
      h="full"
      overflow="hidden"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
    >
      {/* Placeholder for chat content */}
      <Box>
        {/* Title/Heading Skeleton */}
        <Skeleton
          height="2rem"
          width="50%"
          borderRadius="md"
          startColor={skeletonStartColor}
          endColor={skeletonEndColor}
        />

        {/* Chat message skeletons */}
        <Box mt={5}>
          {Array(6)
            .fill("")
            .map((_, index) => (
              <Skeleton
                key={"Chatbox-shimmer-" + index}
                height="2.5rem"
                mb={4}
                width="100%"
                borderRadius="md"
                startColor={skeletonStartColor}
                endColor={skeletonEndColor}
              />
            ))}
        </Box>
      </Box>

      {/* Input Bar Skeleton */}
      <Skeleton
        height="3rem"
        width="100%"
        borderRadius="md"
        startColor={skeletonStartColor}
        endColor={skeletonEndColor}
      />
    </Box>
  );
};

export default ChatBoxShimmer;
